import {
  EMAIL_TEMPLATES_SET_USER_FOLDERS,
  EMAIL_TEMPLATES_SET_SHARED_FOLDERS,
  EMAIL_TEMPLATES_SET_SELECTED_FOLDER,
  EMAIL_TEMPLATES_SET_EDIT_FOLDERS,
  EMAIL_TEMPLATES_DELETE_USER_FOLDERS,
  EMAIL_TEMPLATES_SET_FOLDERS_ORDER,
  EMAIL_TEMPLATES_UPDATE_FOLDER_NAME,
  EMAIL_TEMPLATES_CREATE_USER_FOLDERS,
  EMAIL_TEMPLATES_CREATE_EDIT_FOLDERS,
  EMAIL_TEMPLATES_DELETE_EDIT_FOLDERS,
  EMAIL_TEMPLATES_SET_DELETED_FOLDERS,
} from './actionType';

export const userFolders = (state = [], action) => {
  const { type, payload } = action;
  switch (type) {
    case EMAIL_TEMPLATES_SET_USER_FOLDERS:
      return action.userFolders;
    case EMAIL_TEMPLATES_DELETE_USER_FOLDERS:
      return state.filter(item => item.id !== action.id);
    case EMAIL_TEMPLATES_CREATE_USER_FOLDERS:
      return [...state, payload];
    default:
      return state;
  }
};

export const sharedFolders = (state = [], action) => {
  const { type, ...payload } = action;
  switch (type) {
    case EMAIL_TEMPLATES_SET_SHARED_FOLDERS:
      return action.sharedFolders;
    default:
      return state;
  }
};

export const selectedFolder = (state = {}, action) => {
  const { type } = action;
  switch (type) {
    case EMAIL_TEMPLATES_SET_SELECTED_FOLDER:
      return action.selectedFolder;
    default:
      return state;
  }
};

export const editFolders = (state = [], action) => {
  const { type, payload } = action;
  switch (type) {
    case EMAIL_TEMPLATES_SET_EDIT_FOLDERS:
      return action.editFolders;
    case EMAIL_TEMPLATES_CREATE_EDIT_FOLDERS:
      return [...state, payload];
    case EMAIL_TEMPLATES_DELETE_EDIT_FOLDERS:
      return state.filter(item => item.id !== action.id);
    case EMAIL_TEMPLATES_SET_FOLDERS_ORDER:
      return payload;
    case EMAIL_TEMPLATES_UPDATE_FOLDER_NAME:
      const cloneState = _.cloneDeep(state);
      _.update(
        _.find(cloneState, { id: payload.id }),
        'name',
        () => payload.name,
      );
      return cloneState;
    default:
      return state;
  }
};

export const deletedFolders = (state = [], action) => {
  const { type, id, ids } = action;
  switch (type) {
    case EMAIL_TEMPLATES_DELETE_EDIT_FOLDERS:
      return id > 0 ? [...state, id] : [...state];
    case EMAIL_TEMPLATES_SET_DELETED_FOLDERS:
      return ids;
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/views/email/emailTemplates/flow/folderFlow/reducer.js